module.exports = __webpack_public_path__ + "static/media/AB_B2_5.1a05e319.JPG";